import { render, staticRenderFns } from "./PhysicalCardDetailPane.vue?vue&type=template&id=38afce44&scoped=true"
import script from "./PhysicalCardDetailPane.vue?vue&type=script&lang=js"
export * from "./PhysicalCardDetailPane.vue?vue&type=script&lang=js"
import style0 from "./PhysicalCardDetailPane.vue?vue&type=style&index=0&id=38afce44&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38afce44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38afce44')) {
      api.createRecord('38afce44', component.options)
    } else {
      api.reload('38afce44', component.options)
    }
    module.hot.accept("./PhysicalCardDetailPane.vue?vue&type=template&id=38afce44&scoped=true", function () {
      api.rerender('38afce44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/gift_card/PhysicalCardDetailPane.vue"
export default component.exports